module.exports = __webpack_public_path__ + "img/logo-new.57b0a3b7.png";